import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const OttServiceOptionsLoader = (): any => {
  return (
    <div className='mt-4 d-flex flex-column'>
      <div className='d-flex'>
        <div>
          <SkeletonTheme duration={2} width={40} height={40}>
            <Skeleton />
          </SkeletonTheme>
        </div>
        <div className='ms-2'>
          <SkeletonTheme duration={2} height={16} width={120}>
            <Skeleton />
          </SkeletonTheme>
          <SkeletonTheme duration={2} height={16} width={150}>
            <Skeleton />
          </SkeletonTheme>
        </div>
      </div>
      <div
        className='d-flex gap-2 overflow-auto'
        style={{ scrollbarWidth: 'none', borderRadius: '8px' }}
      >
        {new Array(3).fill(0).map((_, ind) => (
          <div
            style={{ minHeight: '140px', minWidth: '210px', backgroundColor: '#f7f6f5' }}
            className='card mt-2 p-2'
          >
            <SkeletonTheme duration={2} height={16} width={100}>
              <Skeleton />
            </SkeletonTheme>
            <SkeletonTheme duration={2} height={16} width={120}>
              <Skeleton />
            </SkeletonTheme>
            <div className='mt-1'>
              <SkeletonTheme duration={2} height={16} width='100%'>
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </SkeletonTheme>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OttServiceOptionsLoader;
